import { loadingText, messageDuration, title, publicPath } from '@/config'
import { registerMessageClick } from '@/utils/errorPrint'
import { noop } from '@/utils/index'

import { Loading, Message, MessageBox, Notification } from 'element-ui'
import store from '@/store'
import router from '@/router'
import app from '@/init'
const hostPath = `${window.location.protocol}//${window.location.host}${publicPath}`

const install = (Vue) => {
  /* 全局标题 */
  Vue.prototype.$baseTitle = (() => {
    return title
  })()
  /* 全局加载层 */
  Vue.prototype.$baseLoading = (index, text) => {
    let loading
    if (!index) {
      loading = Loading.service({
        lock: true,
        text: text || loadingText,
        background: 'hsla(0,0%,100%,.8)',
      })
    } else {
      loading = Loading.service({
        lock: true,
        text: text || loadingText,
        spinner: 'app-loading-type' + index,
        background: 'hsla(0,0%,100%,.8)',
      })
    }
    return loading
  }
  /* 全局Message */
  Vue.prototype.$baseMessage = (message, type, errorMessageClosed = noop) => {
    const timestamp = new Date().getTime()
    return new Promise((resolve) => {
      const btnText = app.$t('eip.flow.feedback')

      const isError = type === 'error'

      const errorTemplate = `
        <span id="el-message-text-${timestamp}">${message}</span>
        <span id="el-message-button-${timestamp}" class="el-message-button">${btnText}</span>
      `

      Message({
        offset: 60,
        message: isError ? errorTemplate : message,
        type: type || 'success',
        dangerouslyUseHTMLString: isError,
        duration: isError ? 3000 : messageDuration,
        showClose: isError,
        onClose: () => {
          isError && errorMessageClosed()

          resolve()
        },
      })

      isError && registerMessageClick(timestamp)
    })
  }

  /* 全局Alert */
  Vue.prototype.$baseAlert = (content, title, callback) => {
    MessageBox.alert(content, title || app.$t('eip.common.warmPrompt'), {
      confirmButtonText: app.$t('eip.common.confirm'),
      dangerouslyUseHTMLString: true,
      callback: (action) => {
        if (callback) {
          callback(action)
        }
      },
    })
  }

  /* 全局Confirm */
  Vue.prototype.$baseConfirm = (content, title, callback1, callback2) => {
    MessageBox.confirm(content, title || app.$t('eip.common.warmPrompt'), {
      confirmButtonText: app.$t('eip.common.confirm'),
      cancelButtonText: app.$t('eip.common.cancel'),
      closeOnClickModal: false,
      type: 'warning',
    })
      .then(() => {
        if (callback1) {
          callback1()
        }
      })
      .catch(() => {
        if (callback2) {
          callback2()
        }
      })
  }

  /* 全局Notification */
  Vue.prototype.$baseNotify = (message, title, type, position, offset) => {
    Notification({
      title: title,
      message: message,
      position: position || 'top-right',
      type: type || 'success',
      duration: messageDuration,
      offset: offset || 50,
    })
  }

  /* 全局TableHeight */
  Vue.prototype.$baseTableHeight = (adjustHeight) => {
    const fullScreenState = store.getters['routes/fullScreenState']
    let height = window.innerHeight
    let paddingHeight = fullScreenState ? 120 : 172

    if ('number' == typeof adjustHeight) {
      height = height - paddingHeight + adjustHeight
    } else {
      height = height - paddingHeight
    }
    return height
  }

  /* 全局事件总线 */
  Vue.prototype.$baseEventBus = new Vue()

  /* tabs的通用操作 */
  Vue.prototype.$tabs = {
    open: (url) => {
      if (!url) {
        console.error(`URL can not be empty when open new tab.`)
        return
      }
      // 是否完整的url地址
      if (/^http(s?):\/\/.*$/.test(url)) {
        // 是完整的url地址而且是当前系统的地址
        if (url.startsWith(hostPath)) {
          router.push(url.replace(hostPath, ''))
        } else {
          // 非当前系统的地址
          window.open(url)
        }
      } else {
        router.push(url)
      }
    },
    close: (route) => {
      const fullScreenState = store.getters['routes/fullScreenState']
      // 是否全屏方式打开的页面
      if (fullScreenState && !route?.query?.__isFull__) {
        window.close()
      } else {
        store
          .dispatch('tabsBar/delVisitedRoute', route || router.currentRoute)
          .then((visitedRoutes) => {
            const latestView = visitedRoutes.slice(-1)[0]
            if (latestView) {
              router.push({
                path: latestView.fullPath,
              })
            } else {
              router.push('/')
            }
          })
      }
    },
    replace: (route) => {
      Vue.prototype.$tabs.close(route)
      route && setTimeout(() => router.replace(route), 500)
    },
    closeAndReplace: (route) => {
      const fullScreenState = store.getters['routes/fullScreenState']
      // 是否全屏方式打开的页面
      if (fullScreenState && !route?.query?.__isFull__) {
        window.close()
        return
      }

      if (!route) {
        router.replace('/')
        return
      }

      // 等第一次导航（replace '/'）真正落地后再跳目标路由
      // 避免弱网下 refreshToken 耗时 > 500ms 导致两次 replace 打架引发组件复用串单
      const unregister = router.afterEach(() => {
        unregister() // 只执行一次，立即注销，不影响其他 afterEach 监听
        router.replace(route)
      })
      router.replace('/')
    },
    reload: () => {
      let viewElementAry = document.getElementsByName('app-base-main')
      if (!viewElementAry || viewElementAry.length != 1) {
        window.location.reload()
      } else {
        let viewInst = viewElementAry[0].__vue__
        if (!viewInst || !viewInst._isVue) {
          window.location.reload()
        }
        window.location.reload()
      }
    },
  }

  /**
   * 附件
   */
  Vue.prototype.$file = {
    header: () => {
      const tokens = store.getters['user/tokens']
      return {
        'P-Auth': tokens.token,
        'P-RToken': tokens.rtoken,
      }
    },
    actionUrl: `${context.portal}/system/file/v1/upload`,
    previewUrl: `${context.portal}/file/onlinePreviewController/v1/onlinePreview`,
    downloadUrl: `${context.portal}/system/file/v1/downloadFile`,
    watermarkOptions: () => {
      const username = store.getters['user/username']
      return {
        text: `门户POC ${username}`,
      }
    },
  }
}

export default install
